module.exports = __webpack_public_path__ + "img/last-activity.1d490df2.svg";